/* External */
import { useEffect, useRef, useState } from "react";
import { format, getSeconds } from "date-fns";

/**
 * @method toUnixTimestamp
 * @description Method that converts a Date object to a Unix (seconds) timestamp
 * @param {Date} date Date to convert
 */
export const toUnixTimestamp = (date) => Math.floor(date.getTime() / 1000);

export const getFormattedDuration = (seconds, minutesFormat, hoursFormat) => {
  const auxDate = new Date();
  const desidedHoursFormat = hoursFormat || (seconds >= 7200 ? "h 'hs' " : "h 'h' ");
  const desidedMinutesFormat = minutesFormat || "m 'min'";

  auxDate.setHours(0, 0, seconds || 0);

  const showHours = seconds >= 3600 || !seconds;
  const showMinutes = minutesFormat || seconds % 3600 > 60;

  return showHours || showMinutes
    ? format(auxDate, `${showHours ? desidedHoursFormat : ""}${showMinutes ? desidedMinutesFormat : ""}`)
    : "";
};

/**
 * @method useCurrentTime
 * @description Hook that returns current time every minute
 */
export const useCurrentTime = () => {
  const now = new Date();
  const [currentTime, setCurrentTime] = useState(now);
  const initialTimeRef = useRef(now);
  const updateInterval = useRef();

  useEffect(() => {
    const remainingMiliseconds = 60500 - getSeconds(initialTimeRef.current) * 1000;

    const firstUpdateTimeout = setTimeout(() => {
      setCurrentTime(new Date());

      updateInterval.current = setInterval(() => setCurrentTime(new Date()), 60000);
    }, remainingMiliseconds);

    return () => {
      clearTimeout(firstUpdateTimeout);
      clearInterval(updateInterval);
    };
  }, []);

  return currentTime;
};
